exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-link[data-v-34f72ff2] {\n  margin-right: 20px;\n  display: flex;\n  align-items: center;\n}\n.app-link.black[data-v-34f72ff2] {\n  filter: drop-shadow(0px 0px 5px #39c0ee);\n}\n", ""]);

// exports
